// extracted by mini-css-extract-plugin
export default {"details-min-width":"CaseActivity_details-min-width__R-0yd"};